export function getBordersPros(props) {
    var toUseStyle = {};
    if (props.borderLeft === true)
        props.borderLeft = 1;
    if (props.borderRight === true)
        props.borderRight = 1;
    if (props.borderBottom === true)
        props.borderBottom = 1;
    if (props.borderTop === true)
        props.borderTop = 1;
    if (props.borderAll === true || props.border === true) {
        if (!props.borderLeft)
            props.borderLeft = 1;
        if (!props.borderRight)
            props.borderRight = 1;
        if (!props.borderBottom)
            props.borderBottom = 1;
        if (!props.borderTop)
            props.borderTop = 1;
    }
    else if (typeof props.borderAll === 'number') {
        if (!props.borderLeft)
            props.borderLeft = props.borderAll;
        if (!props.borderRight)
            props.borderRight = props.borderAll;
        if (!props.borderBottom)
            props.borderBottom = props.borderAll;
        if (!props.borderTop)
            props.borderTop = props.borderAll;
    }
    else if (typeof props.border === 'number') {
        if (!props.borderLeft)
            props.borderLeft = props.border;
        if (!props.borderRight)
            props.borderRight = props.border;
        if (!props.borderBottom)
            props.borderBottom = props.border;
        if (!props.borderTop)
            props.borderTop = props.border;
    }
    if (props.borderLeft && props.borderLeft <= 5)
        props["border-l-".concat(props.borderLeft)] = true;
    if (props.borderRight && props.borderRight <= 5)
        props["border-r-".concat(props.borderRight)] = true;
    if (props.borderBottom && props.borderBottom <= 5)
        props["border-b-".concat(props.borderBottom)] = true;
    if (props.borderTop && props.borderTop <= 5)
        props["border-t-".concat(props.borderTop)] = true;
    if (props.rounded)
        toUseStyle.borderRadius = '5px';
    else if (props.circle)
        toUseStyle.borderRadius = '50%';
    else if (typeof props.borderRadius !== 'undefined')
        toUseStyle.borderRadius = props.borderRadius;
    else if (typeof props.borderRadiusAll !== 'undefined')
        toUseStyle.borderRadius = props.borderRadiusAll;
    if (typeof props.borderRadiusBottom !== 'undefined')
        toUseStyle.borderEndEndRadius = props.borderRadiusBottom;
    if (typeof props.borderRadiusTop !== 'undefined')
        toUseStyle.borderStartStartRadius = props.borderRadiusTop;
    if (typeof props.borderRadiusBottomLeft !== 'undefined')
        toUseStyle.borderBottomLeftRadius = props.borderRadiusBottomLeft;
    if (typeof props.borderRadiusBottomRight !== 'undefined')
        toUseStyle.borderBottomRightRadius = props.borderRadiusBottomRight;
    if (typeof props.borderRadiusLeft !== 'undefined') {
        toUseStyle.borderTopLeftRadius = props.borderRadiusLeft;
        toUseStyle.borderBottomLeftRadius = props.borderRadiusLeft;
    }
    if (typeof props.borderRadiusRight !== 'undefined') {
        toUseStyle.borderTopRightRadius = props.borderRadiusRight;
        toUseStyle.borderBottomRightRadius = props.borderRadiusRight;
    }
    if (typeof props.borderRadiusTopLeft !== 'undefined')
        toUseStyle.borderTopLeftRadius = props.borderRadiusTopLeft;
    if (typeof props.borderRadiusTopRight !== 'undefined')
        toUseStyle.borderTopRightRadius = props.borderRadiusTopRight;
    var classes = {
        'border-dotted': props.borderDotted
    };
    Object.keys(props).filter(function (key) { return key.startsWith('border-'); }).forEach(function (key) { return classes[key] = true; });
    Object.keys(props).filter(function (key) { return key.startsWith('border-radius-'); }).forEach(function (key) { return classes[key] = true; });
    return {
        classes: classes,
        props: {},
        styles: toUseStyle,
        variables: {}
    };
}
